import { ICalculatedRate, IDisclosureInformation, IRate } from "../../models/IRate";

function getPaymentCount(disclosureInformation: IDisclosureInformation): number {
    if (disclosureInformation.isBalloonLoan && disclosureInformation.termMonths) {
        return disclosureInformation.termMonths;
    }
    return disclosureInformation.paymentCount ? disclosureInformation.paymentCount : disclosureInformation.termMonths;
}

export function calculateMonthlyPayment(rateObject: IRate, downPaymentOrRefinanceAmount: number, purchasePriceOrHomeValue: number, isPurchase: boolean, valueOffset: number): ICalculatedRate {
    const monthsInYear = 12;
    const loanValue = isPurchase ? purchasePriceOrHomeValue - downPaymentOrRefinanceAmount : downPaymentOrRefinanceAmount;

    const modifiedApr = rateObject.rate.disclosureInformation.apr + valueOffset;
    const modifiedInitialRate = rateObject.rate.initialRate + valueOffset;

    const paymentCount = getPaymentCount(rateObject.rate.disclosureInformation);
    const rateDecimal = modifiedInitialRate / 100;
    const monthlyRate = rateDecimal / monthsInYear;
    const power = Math.pow(1 + monthlyRate, paymentCount);

    const monthlyPayment = loanValue * (monthlyRate * power / (power - 1));
    // Loan term is used for the detailed quote request and it needs paymentCount when it exists regardless if the loan is a balloon one
    const loanTermPaymentCount = rateObject.rate.disclosureInformation.paymentCount || rateObject.rate.disclosureInformation.termMonths;
    const loanTerm = loanTermPaymentCount / monthsInYear;
    
    return { ...rateObject, modifiedApr, loanTerm, monthlyPayment, modifiedInitialRate };
}